const getSlider = (colors) => ({
  thumb: colors.pumpkin50,
  thumbBorder: colors.pumpkin50,
  thumbShadow: colors.pumpkin50,
  trackBackground: colors.pumpkin05,
  trackFilled: colors.pumpkin50,
})

export default getSlider
